export default __webpack_public_path__ + "static/media/1.4fc2f332.jpg";